import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export const testimonials = [
  {
    id: '1',
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20photo%2C%20friendly%20smile%2C%20clean%20simple%20background%2C%20soft%20natural%20lighting%2C%20modern%20professional%20headshot&width=100&height=100&seq=avatar-01&orientation=squarish',
    comment: '91片库真的太棒了！资源丰富更新又快，画质清晰不卡顿，而且完全没有广告，看剧体验一流。已经推荐给身边所有朋友了！',
    rating: 5,
    date: '2026-08-04',
  },
  {
    id: '2',
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Attractive%20Chinese%20female%20portrait%20photo%2C%20warm%20smile%2C%20clean%20simple%20background%2C%20soft%20natural%20lighting%2C%20modern%20professional%20headshot&width=100&height=100&seq=avatar-02&orientation=squarish',
    comment: '每天下班回家就打开91片库追剧，多线路切换功能很实用，再也不怕卡顿了。高清画质在大屏上看太享受了！',
    rating: 5,
    date: '2026-08-03',
  },
  {
    id: '3',
    name: '王同学',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%20photo%2C%20confident%20expression%2C%20clean%20simple%20background%2C%20soft%20natural%20lighting%2C%20modern%20casual%20headshot&width=100&height=100&seq=avatar-03&orientation=squarish',
    comment: '作为一个电影爱好者，91片库的资源库让我惊喜！从经典老片到最新大片应有尽有，分类清晰找片超方便。',
    rating: 5,
    date: '2026-08-02',
  },
  {
    id: '4',
    name: '赵老师',
    avatar: 'https://readdy.ai/api/search-image?query=Middle-aged%20Chinese%20professional%20portrait%20photo%2C%20warm%20friendly%20expression%2C%20clean%20simple%20background%2C%20soft%20natural%20lighting%2C%20modern%20professional%20headshot&width=100&height=100&seq=avatar-04&orientation=squarish',
    comment: '找了很久的纪录片资源，终于在91片库找到了，画质还特别好。BBC和国家地理的纪录片都有，太全了！',
    rating: 4,
    date: '2026-07-30',
  },
];

const faqs = [
  {
    question: '91片库需要注册才能观看吗？',
    answer: '不需要。91片库所有资源均可免费在线观看，无需注册或登录。我们致力于为用户提供最便捷的观影体验，打开即看，无需任何门槛。',
  },
  {
    question: '91片库的视频清晰度如何？',
    answer: '91片库提供多种清晰度选择，包括720P、1080P、2K和4K超清画质。您可以根据网络状况和设备性能自由切换，确保最佳观影体验。',
  },
  {
    question: '91片库的资源更新速度怎么样？',
    answer: '91片库与国内外主流影视平台保持同步更新，热门电影和电视剧通常在首播后24小时内上线。我们的编辑团队全天候监控资源更新，确保您第一时间看到最新内容。',
  },
  {
    question: '在手机上能用91片库吗？',
    answer: '当然可以！91片库完美适配手机、平板、电脑等多种设备，支持iOS和Android系统。无论您在哪里，打开浏览器就能畅享高清影视。',
  },
  {
    question: '观看时会遇到广告吗？',
    answer: '91片库承诺全程无广告干扰。从打开页面到开始播放，您不会看到任何弹窗广告、贴片广告或插播广告，纯粹享受观影乐趣。',
  },
];

export default function About() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  useEffect(() => {
    const existingOrg = document.getElementById('schema-org-about');
    const existingFaq = document.getElementById('schema-faq-about');
    const existingBc = document.getElementById('schema-breadcrumb-about');
    if (existingOrg) existingOrg.remove();
    if (existingFaq) existingFaq.remove();
    if (existingBc) existingBc.remove();

    const orgSchema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '91片库',
      url: 'https://www.91piianku.com',
      description: '91片库 - 在线高清影视资源平台',
      contactPoint: { '@type': 'ContactPoint', contactType: 'customer service', email: 'support@91piianku.com' },
    };

    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((f) => ({
        '@type': 'Question',
        name: f.question,
        acceptedAnswer: { '@type': 'Answer', text: f.answer },
      })),
    };

    const breadcrumb = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.91piianku.com' },
        { '@type': 'ListItem', position: 2, name: '关于我们' },
      ],
    };

    [
      { id: 'schema-org-about', content: orgSchema },
      { id: 'schema-faq-about', content: faqSchema },
      { id: 'schema-breadcrumb-about', content: breadcrumb },
    ].forEach(({ id: sid, content }) => {
      const script = document.createElement('script');
      script.id = sid;
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(content);
      document.head.appendChild(script);
    });

    return () => {
      ['schema-org-about', 'schema-faq-about', 'schema-breadcrumb-about'].forEach((elId) => {
        const el = document.getElementById(elId);
        if (el) el.remove();
      });
    };
  }, []);

  return (
    <main className="min-h-screen pt-20 pb-16 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6" aria-label="面包屑导航">
          <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
          <span className="text-foreground-700">/</span>
          <span className="text-foreground-300">关于我们</span>
        </nav>

        {/* Brand Intro */}
        <section className="mb-16 md:mb-20">
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-50 mb-4">关于91片库</h1>
            <p className="text-foreground-500 max-w-2xl mx-auto leading-relaxed">
              您的专属在线影视资源平台
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-100 mb-4">
                我们的使命
              </h2>
              <p className="text-foreground-400 leading-relaxed mb-4">
                91片库成立于2023年，致力于为全球华语用户打造最优质的在线影视资源平台。我们深知好的观影体验始于优质的资源和流畅的播放，因此我们组建了专业的内容团队和技术团队，日以继夜地为大家精选全球优质影视内容。
              </p>
              <p className="text-foreground-400 leading-relaxed mb-4">
                从好莱坞大片到国产精品，从热门综艺到冷门纪录片，从经典老片到最新短剧，91片库拥有覆盖全品类的海量资源库，总资源量超过<strong>50,000部</strong>，且每天持续更新。
              </p>
              <p className="text-foreground-400 leading-relaxed">
                我们坚持<strong>免费、无广告、高清</strong>三大原则，让每一位用户都能在这里享受纯粹的观影乐趣。
              </p>
            </div>
            <div className="rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20home%20cinema%20setup%20with%20large%20screen%20displaying%20movie%20content%2C%20cozy%20living%20room%20with%20warm%20ambient%20lighting%2C%20cinematic%20atmosphere%2C%20professional%20interior%20photography%2C%20clean%20composition&width=800&height=500&seq=about-brand-intro&orientation=landscape"
                alt="91片库品牌理念 - 极致观影体验"
                title="91片库 - 您的专属高清影视平台"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="mb-16 md:mb-20">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {[
              { number: '50,000+', label: '影视资源' },
              { number: '10,000,000+', label: '月活用户' },
              { number: '99.9%', label: '在线率' },
              { number: '24H', label: '更新速度' },
            ].map((stat) => (
              <div key={stat.label} className="text-center p-6 bg-background-100 border border-background-200/40 rounded-xl">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">{stat.number}</div>
                <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Testimonials */}
        <section className="mb-16 md:mb-20">
          <div className="text-center mb-10">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50 mb-2">
              用户口碑
            </h2>
            <p className="text-sm text-foreground-500">听听用户怎么说</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {testimonials.map((t) => (
              <div key={t.id} className="bg-background-100 border border-background-200/40 rounded-xl p-5">
                <div className="flex items-center gap-3 mb-3">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <div className="text-sm font-medium text-foreground-200">{t.name}</div>
                    <div className="flex items-center gap-0.5 mt-0.5">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`text-xs ${i < t.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-700'}`}
                        ></i>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-sm text-foreground-400 leading-relaxed">{t.comment}</p>
                <p className="text-xs text-foreground-600 mt-3">{t.date}</p>
              </div>
            ))}
          </div>
        </section>

        {/* FAQ */}
        <section className="mb-16 md:mb-20">
          <div className="text-center mb-10">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50 mb-2">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500">关于91片库，你可能想知道</p>
          </div>
          <div className="max-w-[800px] mx-auto space-y-3">
            {faqs.map((faq, idx) => (
              <details key={idx} className="group bg-background-100 border border-background-200/40 rounded-xl overflow-hidden cursor-pointer">
                <summary className="px-5 py-4 text-sm font-medium text-foreground-200 list-none flex items-center justify-between cursor-pointer">
                  {faq.question}
                  <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform w-5 h-5 flex items-center justify-center"></i>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-400 leading-relaxed">
                  {faq.answer}
                </div>
              </details>
            ))}
          </div>
        </section>

        {/* Contact */}
        <section className="mb-10">
          <div className="text-center mb-10">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50 mb-2">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500">有任何问题或建议，随时与我们联系</p>
          </div>
          <div className="max-w-[600px] mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
              <div className="text-center p-4 bg-background-100 border border-background-200/40 rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2 rounded-full bg-primary-500/10">
                  <i className="ri-mail-line text-primary-500 text-lg"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">邮箱</div>
                <div className="text-sm text-foreground-200">support@91piianku.com</div>
              </div>
              <div className="text-center p-4 bg-background-100 border border-background-200/40 rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2 rounded-full bg-accent-500/10">
                  <i className="ri-customer-service-2-line text-accent-500 text-lg"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">客服</div>
                <div className="text-sm text-foreground-200">7×24小时在线</div>
              </div>
              <div className="text-center p-4 bg-background-100 border border-background-200/40 rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2 rounded-full bg-secondary-500/10">
                  <i className="ri-global-line text-secondary-500 text-lg"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">官网</div>
                <div className="text-sm text-foreground-200">www.91piianku.com</div>
              </div>
            </div>

            <form
              action="https://readdy.ai/api/form/d9pmbm1n2trhb35gvhr0"
              method="POST"
              data-readdy-form=""
              className="bg-background-100 border border-background-200/40 rounded-xl p-6"
              onSubmit={(e) => {
                const honey = (e.currentTarget.querySelector('input[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
                if (honey) {
                  e.preventDefault();
                  return;
                }
              }}
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div>
                  <label htmlFor="contact-name" className="block text-sm text-foreground-400 mb-1.5">姓名</label>
                  <input
                    id="contact-name"
                    name="name"
                    type="text"
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200/50 rounded-lg text-foreground-200 placeholder-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="contact-email" className="block text-sm text-foreground-400 mb-1.5">邮箱</label>
                  <input
                    id="contact-email"
                    name="email"
                    type="email"
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200/50 rounded-lg text-foreground-200 placeholder-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors"
                    placeholder="请输入您的邮箱"
                  />
                </div>
              </div>
              <div className="mb-4">
                <label htmlFor="contact-subject" className="block text-sm text-foreground-400 mb-1.5">主题</label>
                <select
                  id="contact-subject"
                  name="subject"
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200/50 rounded-lg text-foreground-200 focus:outline-none focus:border-primary-500/50 transition-colors cursor-pointer"
                >
                  <option value="">请选择主题</option>
                  <option value="资源建议">资源建议</option>
                  <option value="播放问题">播放问题</option>
                  <option value="合作咨询">合作咨询</option>
                  <option value="其他">其他</option>
                </select>
              </div>
              <div className="mb-4">
                <label htmlFor="contact-message" className="block text-sm text-foreground-400 mb-1.5">留言内容</label>
                <textarea
                  id="contact-message"
                  name="message"
                  rows={4}
                  maxLength={500}
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200/50 rounded-lg text-foreground-200 placeholder-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors resize-none"
                  placeholder="请输入您的留言，最多500字"
                ></textarea>
              </div>
              <div className="hp-field">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" readOnly aria-hidden="true" />
              </div>
              <button
                type="submit"
                className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-medium rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                发送留言
              </button>
            </form>
          </div>
        </section>
      </div>
    </main>
  );
}